import { App } from "vue";

const requireComponent = require.context(
  "@/components/global",
  true,
  /.*\.vue$/
);

const register = (app: App<Element>): void => {
  requireComponent.keys().forEach((fileName) => {
     // Get component config
    const componentConfig = requireComponent(fileName);
    // Get component name
    const componentName = fileName
      .split("/")
      .pop()
      ?.replace(/\.\w+$/, "") as string;

    // console.log("register component Name =>", componentName,fileName);
    app.component(componentName, componentConfig.default || componentConfig);
  });
};

export default {
  register,
};
